import { PageTitle } from '_metronic/layout/core'
import { WithChildren } from '_metronic/helpers'

// import AsyncSelect from 'react-select/async'
import JobStatusChanger from '../../Components/JobStatusChanger'
import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'
import Select from 'react-select'
import Datetime from 'react-datetime'
import StatusCell from '../../List/Components/StatusCell'

import useViewModel from './ViewModel'
import clsx from 'clsx'
import moment from 'moment'
import { findReactSelectOption } from 'Utils/findReactSelectOption'

const IssueRequestChangeShipping: React.FC = () => {
  const {
    pileOptions,
    cancel,
    disabledSubmitButton,
    findedSaleOrder,
    originalJobStatus,
    formik,
    isCreate,
    isView,
    saleOrder,
    openJobStatusChanger,
    onSubmitStatus,
    handleOpenJobStatusChanger,
    handleCloseJobStatusChanger,
    onChangeJobStatus,
  } = useViewModel()

  // const [hasType, setHasType] = useState(false)

  // const onSearchCode = (val: string, callback: (options: any[]) => void) => {
  //   if (!isCreate && hasType === false) {
  //     setHasType(true)
  //   }

  //   if (val.length >= 3) {
  //     const options = MasterPileData.filter(item => item.code.includes(val)).map(item => ({
  //       label: item.code,
  //       value: item.code,
  //     }))
  //     callback(options)
  //   }

  //   callback([])
  // }

  const onChangeCode = (val: any) => {
    const item = pileOptions.find(item => item.value === val)

    formik.setFieldValue('pileCode', item?.value)
  }

  return (
    <ViewPageTitle isCreate={isCreate} isView={isView}>
      <JobStatusChanger
        open={openJobStatusChanger}
        value={formik.values.jobStatus}
        onChange={onChangeJobStatus}
        handleClose={handleCloseJobStatusChanger}
        handleSubmit={onSubmitStatus}
      />

      <div className='row gy-5 mb-5'>
        <div className='col-12'>
          <PageBreadCrumb />
        </div>

        <div className='col-12'>
          <div className='card'>
            <div className='card-footer'>
              <div className='d-flex justify-content-between align-items-center'>
                <div>
                  สถานะงาน: <StatusCell status={originalJobStatus} />
                </div>
                <div className='text-end'>
                  {!isCreate && !isView && (
                    <button
                      type='button'
                      className='btn btn-sm btn-primary fw-bold me-4'
                      onClick={handleOpenJobStatusChanger}>
                      แก้ไขสถานะงาน
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='col-12'>
          <form
            onSubmit={(e: any) => {
              e.preventDefault()
              formik.handleSubmit(e)
            }}>
            <div className='card'>
              <div className='card-body'>
                <div className='row gy-3'>
                  {/* Sale Order */}
                  <div className='col-12 col-xl-3'>
                    <label className='mb-2'>
                      Sale Order ID. <span className='required' />
                    </label>

                    <Select
                      name='saleOrderId'
                      isSearchable={true}
                      styles={{
                        control: (provided: any) => ({
                          ...provided,
                          borderColor:
                            formik.touched.saleOrderId && formik.errors.saleOrderId
                              ? 'red'
                              : '#e1e3ea',
                        }),
                      }}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                      options={saleOrder}
                      onBlur={() => formik.setFieldTouched('saleOrderId')}
                      onChange={(selectedOption: any) => {
                        if (selectedOption)
                          formik.setFieldValue('saleOrderId', selectedOption.value)
                      }}
                      value={findReactSelectOption({
                        value: formik.getFieldProps('saleOrderId').value,
                        options: saleOrder,
                      })}
                    />

                    {formik.touched.saleOrderId && formik.errors.saleOrderId && (
                      <div className='fv-plugins-message-container mt-2'>
                        <div className='fv-help-block'>{formik.errors.saleOrderId}</div>
                      </div>
                    )}
                  </div>

                  {/* Division */}
                  <div className='col-12 col-xl-3'>
                    <label className='mb-2'>
                      ชื่อหน่วยงาน <span className='required' />
                    </label>
                    <input
                      type='text'
                      disabled
                      className={clsx('form-control form-control-sm', {
                        'is-invalid': formik.touched.saleOrderId && formik.errors.saleOrderId,
                      })}
                      value={findedSaleOrder?.division ?? ''}
                      onChange={(e: any) => {}}
                    />

                    {formik.touched.saleOrderId && formik.errors.saleOrderId && (
                      <div className='fv-plugins-message-container mt-2'>
                        <div className='fv-help-block'>{formik.errors.saleOrderId}</div>
                      </div>
                    )}
                  </div>

                  {/* Requested At */}
                  <div className='col-12 col-xl-3'>
                    <label className='mb-2'>
                      วันที่แจ้ง <span className='required' />
                    </label>
                    <Datetime
                      locale='en'
                      dateFormat='DD/MM/YYYY'
                      timeFormat={false}
                      renderInput={props => {
                        return (
                          <input
                            {...props}
                            autoComplete='off'
                            className={clsx(props.className, {
                              'is-invalid': formik.touched.requestedAt && formik.errors.requestedAt,
                            })}
                          />
                        )
                      }}
                      closeOnClickOutside
                      className='filter-date-input w-100 z-4'
                      value={formik.values.requestedAt}
                      onChange={(val: any) => formik.setFieldValue('requestedAt', val)}
                    />

                    {formik.touched.requestedAt && formik.errors.requestedAt && (
                      <div className='fv-plugins-message-container mt-2'>
                        {/* @ts-ignore */}
                        <div className='fv-help-block'>{formik.errors.requestedAt}</div>
                      </div>
                    )}
                  </div>

                  <div className='col-12 col-xl-3'>
                    ผู้ขอ <span className='required'></span>
                    <span className='align-items-center d-flex flex-row mt-2'>
                      <div className='position-relative w-100'>
                        <input
                          type='text'
                          className={clsx('form-control form-control-sm', {
                            'is-invalid': formik.touched.requester && formik.errors.requester,
                          })}
                          {...formik.getFieldProps('requester')}
                        />
                        <div
                          className='position-absolute text-gray-500'
                          style={{ top: '22%', right: 10 }}>
                          {/* (แผ่น) */}
                        </div>
                      </div>
                    </span>
                    {formik.touched.requester && formik.errors.requester && (
                      <div className='fv-plugins-message-container mt-2'>
                        <div className='fv-help-block'>{formik.errors.requester}</div>
                      </div>
                    )}
                  </div>

                  <div className='col-12 mt-10 mb-5'>
                    <span className='fw-bold fs-4'>รายละเอียดของเสา</span>
                  </div>

                  <div className='col-12 col-xl-3'>
                    <label className='mb-2'>
                      วันที่ <span className='required' />
                    </label>
                    <Datetime
                      locale='en'
                      dateFormat='DD/MM/YYYY'
                      timeFormat={false}
                      renderInput={props => {
                        return (
                          <input
                            {...props}
                            autoComplete='off'
                            className={clsx(props.className, {
                              'is-invalid': formik.touched.requireDate && formik.errors.requireDate,
                            })}
                          />
                        )
                      }}
                      closeOnClickOutside
                      className='filter-date-input w-100 z-4'
                      value={formik.values.requireDate}
                      onChange={(val: any) => {
                        // combine new date with old time
                        const time = moment(formik.values.requireDate).format('HH:mm')
                        const date = moment(val).format('YYYY-MM-DD')
                        formik.setFieldValue('requireDate', moment(`${date} ${time}`))
                      }}
                    />

                    {formik.touched.requestedAt && formik.errors.requestedAt && (
                      <div className='fv-plugins-message-container mt-2'>
                        {/* @ts-ignore */}
                        <div className='fv-help-block'>{formik.errors.requestedAt}</div>
                      </div>
                    )}
                  </div>

                  <div className='col-12 col-xl-3'>
                    <label className='mb-2'>
                      เวลา <span className='required' />
                    </label>
                    <Datetime
                      locale='en'
                      dateFormat={false}
                      timeFormat='HH:mm'
                      renderInput={props => {
                        return (
                          <input
                            {...props}
                            autoComplete='off'
                            className={clsx(props.className, {
                              'is-invalid': formik.touched.requireDate && formik.errors.requireDate,
                            })}
                          />
                        )
                      }}
                      closeOnClickOutside
                      className='filter-date-input w-100 z-4'
                      value={formik.values.requireDate}
                      onChange={(val: any) => {
                        // combine new time with old date
                        const time = moment(val).format('HH:mm')
                        const date = moment(formik.values.requireDate).format('YYYY-MM-DD')

                        formik.setFieldValue('requireDate', moment(`${date} ${time}`))
                      }}
                    />

                    {formik.touched.requireDate && formik.errors.requireDate && (
                      <div className='fv-plugins-message-container mt-2'>
                        {/* @ts-ignore */}
                        <div className='fv-help-block'>{formik.errors.requireDate}</div>
                      </div>
                    )}
                  </div>

                  <div className='col-12 col-xl-3'>
                    จำนวนเสาที่ต้องการ <span className='required'></span>
                    <span className='align-items-center d-flex flex-row mt-2'>
                      <div className='position-relative w-100'>
                        <input
                          type='text'
                          className={clsx('form-control form-control-sm', {
                            'is-invalid': formik.touched.quantity && formik.errors.quantity,
                          })}
                          {...formik.getFieldProps('quantity')}
                        />
                        <div
                          className='position-absolute text-gray-500'
                          style={{ top: '22%', right: 10 }}>
                          {/* (แผ่น) */}
                        </div>
                      </div>
                    </span>
                    {formik.touched.quantity && formik.errors.quantity && (
                      <div className='fv-plugins-message-container mt-2'>
                        <div className='fv-help-block'>{formik.errors.quantity}</div>
                      </div>
                    )}
                  </div>

                  <div className='col-12 col-xl-3'>
                    รหัสเสา <span className='required'></span>
                    <span className='w-100 mt-2'>
                      {/* {render ? ( */}
                      <Select
                        className='mt-2'
                        options={pileOptions}
                        onChange={(val: any) => val && onChangeCode(val.value)}
                        value={pileOptions.find(o => o.value === formik.values.pileCode)}
                        styles={{
                          control: (provided: any) => ({
                            ...provided,
                            minHeight: 0,
                            height: 35,
                          }),
                          valueContainer: (provided: any) => ({
                            ...provided,
                            minHeight: 0,
                            height: 35,
                            padding: '0 6px',
                          }),
                        }}
                      />
                      {/* ) : (
                        <input
                          className='form-control form-control-sm'
                          disabled
                          placeholder='Loading...'
                        />
                      )} */}
                    </span>
                    {formik.touched.pileCode && formik.errors.pileCode && (
                      <div className='fv-plugins-message-container mt-2'>
                        <div className='fv-help-block'>{formik.errors.pileCode}</div>
                      </div>
                    )}
                  </div>

                  <div className='col-12'>
                    <label className='mb-2'>คำขอเพิ่มเติม</label>
                    <textarea
                      className='form-control form-control-sm'
                      rows={5}
                      {...formik.getFieldProps('remark')}
                    />
                    {formik.touched.remark && formik.errors.remark && (
                      <div className='fv-plugins-message-container mt-2'>
                        <div className='fv-help-block'>{formik.errors.remark}</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {!isView && (
                <div className='card-footer text-center text-lg-end'>
                  <button
                    className='btn btn-sm btn-secondary fw-bold me-4 w-sm-100 mb-5 mb-xl-0'
                    type='button'
                    onClick={() => cancel()}>
                    ยกเลิก
                  </button>
                  <button
                    className='btn btn-sm btn-primary fw-bold w-sm-100'
                    type='submit'
                    disabled={disabledSubmitButton}>
                    บันทึก
                  </button>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </ViewPageTitle>
  )
}

const ViewPageTitle: React.FC<WithChildren & { isCreate: boolean; isView: boolean }> = ({
  children,
  isCreate,
  isView,
}) => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            isActive: true,
            isSeparator: false,
            path: '/request',
            title: 'รายการทั้งหมด',
            icon: '/media/icons/duotune/files/fil005.svg',
          },
          {
            isActive: true,
            isSeparator: false,
            path: '#',
            title: isView ? 'รายละเอียดการขอ' : isCreate ? 'เพิ่ม' : 'แก้ไข',
          },
        ]}>
        {isView
          ? 'รายละเอียดการขอเพิ่มจำนวน (ขนส่ง)'
          : isCreate
          ? 'สร้างรายการขอเพิ่มจำนวน (ขนส่ง)'
          : 'แก้ไขรายการขอเพิ่มจำนวน (ขนส่ง)'}
      </PageTitle>

      {children}
    </>
  )
}

export default IssueRequestChangeShipping
